var map = {
	"./Other/ecologism-leaf-svgrepo-com.svg": 43,
	"./Other/ecologism-work-svgrepo-com.svg": 44,
	"./Other/studying-work-svgrepo-com.svg": 45,
	"./add-1.svg": 46,
	"./add-2.svg": 47,
	"./add-3.svg": 48,
	"./add-4.svg": 49,
	"./arrow-down.svg": 50,
	"./body.svg": 51,
	"./calendar-1.svg": 52,
	"./calendar-2.svg": 53,
	"./cooking-1.svg": 54,
	"./cooking-2.svg": 55,
	"./cooking-3.svg": 56,
	"./cooking-4.svg": 57,
	"./cooking-5.svg": 58,
	"./cooking-6.svg": 59,
	"./cooking-7.svg": 60,
	"./difficulty-lvl-0.svg": 61,
	"./difficulty-lvl-0v2.svg": 62,
	"./difficulty-lvl-0v3.svg": 63,
	"./difficulty-lvl-1.svg": 64,
	"./difficulty-lvl-1v2.svg": 65,
	"./difficulty-lvl-2.svg": 66,
	"./difficulty-lvl-3.svg": 67,
	"./difficulty-lvl-4.svg": 68,
	"./difficulty-unknown.svg": 69,
	"./difficulty-unknown2.svg": 70,
	"./drawing.svg": 71,
	"./drawing2.svg": 72,
	"./drawing3.svg": 73,
	"./drawing4.svg": 74,
	"./engineering.svg": 75,
	"./engineering2.svg": 76,
	"./engineering3.svg": 77,
	"./engineering4.svg": 78,
	"./environment-1.svg": 79,
	"./environment-2.svg": 80,
	"./environment-3.svg": 81,
	"./environment-4.svg": 82,
	"./environment-5.svg": 83,
	"./finances-1.svg": 84,
	"./finances-2.svg": 85,
	"./finances-3.svg": 86,
	"./health-2.svg": 87,
	"./health-3.svg": 88,
	"./health.svg": 89,
	"./knowledge.svg": 90,
	"./logo.svg": 91,
	"./mind.svg": 92,
	"./more-1.svg": 93,
	"./more-2.svg": 94,
	"./more-3.svg": 95,
	"./more-4.svg": 96,
	"./music.svg": 97,
	"./music2.svg": 98,
	"./music3.svg": 99,
	"./number-1.svg": 100,
	"./number-2.svg": 101,
	"./programming.svg": 102,
	"./quest.svg": 103,
	"./quest2.svg": 104,
	"./quest3.svg": 105,
	"./settings.svg": 106,
	"./settings2.svg": 107,
	"./settings3.svg": 108,
	"./settings4.svg": 109,
	"./social-1.svg": 110,
	"./stats.svg": 111,
	"./stats2.svg": 112,
	"./stats3.svg": 113,
	"./stats4.svg": 114,
	"./stats5.svg": 115,
	"./stats6.svg": 116,
	"./stats7.svg": 117,
	"./text-1.svg": 118,
	"./text-2.svg": 119,
	"./time.svg": 120,
	"./time2.svg": 121,
	"./trash-1.svg": 122,
	"./trash-2.svg": 123,
	"./trash-3.svg": 124,
	"./trash-4.svg": 125
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42;